// test1171
(1171 && 0);
